import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { WidgetTable } from "../Widgets/WidgetTable";
import { DynPopup } from "../../../Components/DynPopup";
import { DropDownComponent } from "../../../Components/DropDownComponent";
import { TextComponent } from "../../../Components/TextComponent";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { app } from "../../../Frame/App";
import { LanguageString } from "../../../Model/LanguageString";
import { WidgetGenericDataTable } from "../Widgets/WidgetGenericDataTable";
import { AceEditorComponent } from "../../../Components/AceEditorComponent";
import { CheckboxCompoment } from "../../../Components/CheckboxComponent";

export type PopupGenericDataTableComponentProps = {
    widget: WidgetGenericDataTable;
}

export class PopupGenericDataTableComponent extends JSXComponent {
    props: PopupGenericDataTableComponentProps;
    title: LanguageStringComponent;
    apiUrl: string;
    jsonData: string;
    availableColumns: string;
    rowClickUrl: string;
    fixedLayout: boolean;
    settingsName: string;
    noClickAction?: boolean;

    constructor(props: PopupGenericDataTableComponentProps) {
        super(props);

        this.apiUrl = this.props.widget.props.apiUrl;
        this.jsonData = this.props.widget.props.jsonData;
        this.availableColumns = this.props.widget.props.availableColumns;
        this.rowClickUrl = this.props.widget.props.rowClickUrl;
        this.fixedLayout = this.props.widget.props.fixedLayout;
        this.settingsName = this.props.widget.props.settingsName;
        this.noClickAction = this.props.widget.props.noClickAction;
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;

        this.props.widget.props.apiUrl = this.apiUrl;
        this.props.widget.props.jsonData = this.jsonData;
        this.props.widget.props.availableColumns = this.availableColumns;
        this.props.widget.props.rowClickUrl = this.rowClickUrl;
        this.props.widget.props.fixedLayout = this.fixedLayout;
        this.props.widget.props.settingsName = this.settingsName;
        this.props.widget.props.noClickAction = this.noClickAction;

        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;
    private getElement = () => {
        return <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetGenericDataTable}>

            {this.renderTitle()}

            <TextComponent model={this} field="apiUrl" name="API URL" />

            <div className="form-group position-relative">
                <label className="form-label">Verfügbare Spalten</label>
                <div className="small-editor h-20 d-flex flex-column">
                    <div className="position-relative flex-grow-1">
                        <AceEditorComponent model={this} field="availableColumns" isCss={false} isJson={true} />
                    </div>
                </div>
            </div>

            <TextComponent model={this} field="rowClickUrl" name="URL beim Klick auf Zeile aufrufen (optional)" />
            <TextComponent model={this} field="settingsName" name="MSO Table SettingsName" />

            <CheckboxCompoment model={this} field="fixedLayout" label="Fixed Layout" />
            <CheckboxCompoment model={this} field="noClickAction" label="Keine Aktion bei Click ausführen" />

            {/*<div style={{ height: "10rem" }}></div>*/}
        </DynPopup>;
    }

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        });
        return this.title.render();
    }

    render(): HTMLElement {
        this.element = this.getElement();
        return this.element;
    }
}
